import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "maintenance-schedule-mileage" };
const _hoisted_2 = ["disabled"];
const _hoisted_3 = ["disabled"];
const _hoisted_4 = {
    key: 2,
    class: "mileage__validation",
    role: "alert"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showMileageQuestion)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                id: "maintenanceScheduleMileageInput",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.questionMileageAnswer) = $event)),
                type: "number",
                class: "mileage__amount form-control",
                min: "0",
                name: "maintenance-schedule-mileage-input",
                "aria-label": "Estimated Mileage",
                disabled: _ctx.fieldIsDisabled,
                required: ""
            }, null, 8 /* PROPS */, _hoisted_2)), [
                [_vModelText, _ctx.questionMileageAnswer]
            ])
            : _createCommentVNode("v-if", true),
        (_ctx.showMileageQuestion)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "submit",
                class: "mileage__submit-btn",
                disabled: _ctx.fieldIsDisabled || _ctx.mileageIsInvalid,
                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.getMaintenanceSchedule($event)))
            }, " Get Maintenance Schedule ", 8 /* PROPS */, _hoisted_3))
            : _createCommentVNode("v-if", true),
        (_ctx.mileageIsInvalid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Mileage must be 0 or greater. "))
            : _createCommentVNode("v-if", true)
    ]));
}
